import { useEffect, useState } from "react";
import { getDigitalCardData, getDownloadPdf } from "../../services/rhapsody/RenewHealthCard";
import { fetchTranslationData } from "../../services/translation/translation";
import { ServiceTranslation } from "../../utils/constants";
import Warning from "../common/Warning";
import { isMobileApp, openPdfToUrl } from "../../utils/util";


function DigitalHealthCard() {

  const [digitalCardData, setDigitalCardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [translationMap, setTranslationMap] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(isMobileApp());
    fetchTranslationData(ServiceTranslation.SickLeave).then((result) => {
      setTranslationMap(result);
    });
    getDigitalCardData().then((res) => {
      if (res.data.returnCode === "1") {
        setDigitalCardData(res.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    }).catch((err) => {
      setLoading(false);

    });
  }, []);



  function handleDownloadHealthCard() {
    getDownloadPdf(digitalCardData)
    .then((response) => {
      const { data } = response;
      const { base64, mrn } = data;
      if (!base64) {
        throw new Error("Base64 data is missing");
      }

      const downloadLink = document.createElement('a');
      downloadLink.href = `data:application/pdf;base64,${base64}`;
      downloadLink.download = `${mrn}.pdf`;

      if (isMobile) {
        let cardUrl = openPdfToUrl(base64);
        window.open(cardUrl, "_parent");
        const mobileLink = document.createElement("a");
        mobileLink.href = cardUrl;
        mobileLink.download = mrn + ".pdf";
        document.body.appendChild(mobileLink);
        mobileLink.click();
        document.body.removeChild(mobileLink);
      } else {
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    })
    .catch((error) => {
      console.error("Failed to download the health card:", error);
      alert("An error occurred while downloading the health card.");
    });
  }

  if (loading) return <div>Loading...</div>;

  if (!digitalCardData) return <Warning heading={translationMap?.noRecordFoundDH}
  desc={translationMap?.noRecordDescDH}></Warning>;

  return <>
        <div className="direction-ltr custombody_color">
            <section className="w-100 clearfix DigitalHealthCardMainSection2" id="CoverPlanActive">
                {!loading && digitalCardData &&
        <div className="Digital_Health_Inner_Box">
                        <div className="digital_info_box" id="pdf-content" style={{
            boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px'
          }}>
                <div className="header_box">
                    <svg width="75" height="21" viewBox="0 0 75 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M58.6327 12.2199L57.9609 12.889L58.6301 13.5607L59.3018 12.8916L58.6327 12.2199Z"
                fill="white" />
                        <path
                  d="M59.3407 18.4812L60.0518 16.4664L60.7629 18.4812H59.3407ZM59.5119 15.2417L57.6288 20.3775H58.6559L59.0115 19.3635H61.0658L61.4214 20.3775H62.4485L60.5654 15.2417H59.4856H59.5119Z"
                  fill="white" />
                        <path
                  d="M54.7975 18.2442H56.8913V17.3487H54.7975V16.1635H57.0757V15.2549H53.8362V20.3907H57.1152V19.482H54.7975V18.2442Z"
                  fill="white" />
                        <path d="M59.9795 12.2149L59.3091 12.8853L59.9795 13.5558L60.65 12.8853L59.9795 12.2149Z"
                fill="white" />
                        <path
                  d="M64.2131 8.2886H64.9242V11.5676H68.8749V7.34045H67.9267V10.6195H65.8724V7.34045H64.2131C62.9358 7.34045 61.9876 8.26227 61.9876 9.53963V10.6063H57.1152C56.4831 10.6063 55.9695 10.0927 55.9695 9.46062V7.32729H55.0214V9.46062C55.0214 10.6195 55.9563 11.5544 57.1152 11.5544H62.9358V9.52646C62.9358 8.63099 63.6469 8.27543 64.2131 8.27543"
                  fill="white" />
                        <path
                  d="M51.8082 17.3092H49.688V15.2549H48.7267V20.3907H49.688V18.2178H51.8082V20.3907H52.7563V15.2549H51.8082V17.3092Z"
                  fill="white" />
                        <path
                  d="M72.4435 7.34045H70.8238V8.2886H72.4435C73.0756 8.2886 73.5892 8.80218 73.5892 9.43428V10.6063H70.2048V11.5544H74.5373V9.42111C74.5373 8.26227 73.6024 7.32729 72.4435 7.32729"
                  fill="white" />
                        <path
                  d="M73.5892 17.3092H71.469V15.2549H70.5209V20.3907H71.469V18.2178H73.5892V20.3907H74.5505V15.2549H73.5892V17.3092Z"
                  fill="white" />
                        <path d="M68.3974 12.2196L67.7264 12.8896L68.3964 13.5605L69.0673 12.8905L68.3974 12.2196Z"
                fill="white" />
                        <path d="M64.0683 15.2549H63.1201V20.3907H66.1226V19.482H64.0683V15.2549Z" fill="white" />
                        <path d="M45.7901 15.2549H44.8419V20.3907H45.7901V15.2549Z" fill="white" />
                        <path
                  d="M26.8798 8.2886H27.9728V10.6195H26.8798C26.2345 10.6195 25.7209 10.0927 25.7209 9.46061C25.7209 8.82852 26.2477 8.30177 26.8798 8.30177M41.6551 8.30177H44.6839C45.316 8.30177 45.8296 8.81535 45.8296 9.44745V10.6195H41.6551V8.30177ZM26.8798 11.5808H49.7934V6.44498H48.8452V10.6326H46.7777V9.46061C46.7777 8.30177 45.8296 7.36679 44.6707 7.36679H41.6419V6.87954H40.6938V10.6458H38.6263V9.47378C38.6263 8.31494 37.6781 7.37996 36.5193 7.37996H33.9777V8.3281H36.5193C37.1514 8.3281 37.665 8.84168 37.665 9.47378V10.6458H31.9234V7.36679H30.9753V10.6458H28.9078V6.87954H27.9596V7.36679H26.8666C25.6946 7.36679 24.7465 8.31494 24.7465 9.47378C24.7465 10.6326 25.6946 11.5939 26.8666 11.5939"
                  fill="white" />
                        <path d="M32.1454 12.2151L31.4762 12.8868L32.1479 13.556L32.8171 12.8842L32.1454 12.2151Z"
                fill="white" />
                        <path d="M27.8534 5.0429L27.1825 5.71288L27.8525 6.38378L28.5234 5.71381L27.8534 5.0429Z"
                fill="white" />
                        <path d="M52.0847 6.43181H51.1366V11.5676H52.0847V6.43181Z" fill="white" />
                        <path d="M26.4987 5.04002L25.8278 5.70999L26.4977 6.3809L27.1686 5.71093L26.4987 5.04002Z"
                fill="white" />
                        <path
                  d="M28.0123 19.0079C27.7226 19.324 27.3407 19.482 26.893 19.482H25.8V16.1635H26.893C27.3539 16.1635 27.7226 16.3215 28.0123 16.6244C28.302 16.9273 28.4469 17.3355 28.4469 17.8228C28.4469 18.31 28.302 18.7051 28.0123 19.0079ZM26.893 15.2417H24.8518V20.3775H26.893C27.6041 20.3775 28.1967 20.1273 28.6707 19.6269C29.1448 19.1265 29.3819 18.5207 29.3819 17.8096C29.3819 17.0985 29.1448 16.4795 28.6707 15.9791C28.1967 15.4919 27.6041 15.2417 26.893 15.2417Z"
                  fill="white" />
                        <path
                  d="M37.8756 19.3108C37.7571 19.4425 37.6123 19.4952 37.4279 19.4952H36.1505V18.2178H37.4279C37.6123 18.2178 37.7571 18.2837 37.8756 18.4022C37.9942 18.5339 38.06 18.6787 38.06 18.8631C38.06 19.0474 37.9942 19.1923 37.8756 19.3108ZM36.1505 16.1503H37.2699C37.4411 16.1503 37.5728 16.203 37.6913 16.3215C37.8098 16.44 37.8625 16.5717 37.8625 16.7429C37.8625 16.9141 37.8098 17.059 37.6913 17.1643C37.5728 17.2828 37.4411 17.3355 37.2699 17.3355H36.1505V16.1372V16.1503ZM38.3497 17.7174C38.6526 17.4672 38.8106 17.1248 38.8106 16.7034C38.8106 16.282 38.6526 15.9396 38.3629 15.6631C38.0732 15.3865 37.7044 15.2549 37.2699 15.2549H35.2024V20.3907H37.4279C37.8625 20.3907 38.2444 20.2458 38.5472 19.9693C38.8501 19.6927 39.0082 19.324 39.0082 18.9026C39.0082 18.626 38.9423 18.389 38.8106 18.1783C38.6921 17.9939 38.5341 17.8491 38.3497 17.7306"
                  fill="white" />
                        <path
                  d="M41.0757 18.4812L41.7868 16.4664L42.4979 18.4812H41.0757ZM41.2469 15.2417L39.3638 20.3775H40.3909L40.7465 19.3635H42.814L43.1695 20.3775H44.1967L42.3136 15.2417H41.2337H41.2469Z"
                  fill="white" />
                        <path
                  d="M33.1744 18.6129C33.1744 18.9026 33.0954 19.1265 32.9242 19.2977C32.753 19.4688 32.5028 19.5479 32.1604 19.5479C31.818 19.5479 31.5546 19.4688 31.3966 19.2977C31.2254 19.1265 31.1464 18.9026 31.1464 18.6129V15.2417H30.1982V18.6524C30.1982 19.2055 30.3826 19.6532 30.7513 19.9824C31.1201 20.3116 31.5941 20.4697 32.1736 20.4697C32.753 20.4697 33.227 20.2985 33.5958 19.9824C33.9645 19.6532 34.1489 19.2055 34.1489 18.6524V15.2417H33.2007V18.6129H33.1744Z"
                  fill="white" />
                        <path d="M30.7895 12.2159L30.12 12.8873L30.7914 13.5568L31.4609 12.8854L30.7895 12.2159Z"
                fill="white" />
                        <path d="M65.9645 16.1635H67.3999V20.3907H68.348V16.1635H69.7702V15.2549H65.9645V16.1635Z"
                fill="white" />
                        <path d="M19.953 18.9684H0.0682373V20.4828H19.953V18.9684Z" fill="white" />
                        <path
                  d="M15.7522 4.81206C15.6864 4.81206 15.66 4.90424 15.7259 4.93058C16.595 5.2993 18.4386 6.37913 18.4386 9.60547V17.4409H19.9662V9.42111C19.9662 6.84004 17.8329 5.03593 15.7654 4.79889"
                  fill="white" />
                        <path
                  d="M6.54722 4.93057C7.41635 5.2993 9.2468 6.37913 9.2468 9.60547V17.4409H10.7744V9.60547C10.7744 6.37913 12.618 5.28613 13.474 4.93057C13.5398 4.90424 13.5135 4.79889 13.4476 4.81205C12.1439 4.95691 10.8139 5.73387 10.0106 6.93222C9.2073 5.73387 7.87726 4.95691 6.57355 4.81205C6.49454 4.81205 6.48137 4.90424 6.53405 4.93057"
                  fill="white" />
                        <path
                  d="M6.17858 5.40465C6.17858 2.17831 8.0222 1.08531 8.87816 0.729752C8.94401 0.703415 8.91767 0.598065 8.85182 0.611234C6.78434 0.848271 4.651 2.63922 4.651 5.23346V17.454H6.17858V5.40465Z"
                  fill="white" />
                        <path
                  d="M11.1299 0.729755C11.9859 1.09848 13.8295 2.17832 13.8295 5.40465V17.454H15.3571V5.23346C15.3571 2.65239 13.2238 0.848274 11.1563 0.611237C11.0904 0.611237 11.0641 0.703418 11.1299 0.729755Z"
                  fill="white" />
                        <path
                  d="M1.59582 9.61864C1.59582 6.3923 3.43945 5.2993 4.30858 4.94374C4.37443 4.9174 4.34809 4.81205 4.28224 4.82522C2.21476 5.04909 0.0814209 6.85321 0.0814209 9.43428V17.454H1.60899V9.61864H1.59582Z"
                  fill="white" />
                    </svg>
                </div>
                <div className="content_box">
                    <div className="digital_box_one">
                        <p>
                            Digital Health Card
                        </p>
                        <p className="arebic_text">
                            البطاقة الصحية الرقمية
                        </p>
                    </div>
                    <div className="digital_box_two">

                        <table>
                            <tr>
                                <td>Name</td>
                                <td> {digitalCardData.fullName}</td>
                                <td>الاسم</td>
                            </tr>
                            <tr>
                                <td>MRN</td>
                                <td> {digitalCardData.mrn}</td>
                                <td>رقم السجل الصحي</td>
                            </tr>
                            <tr>
                                <td>Date of Birth</td>
                                <td> {digitalCardData.dob}</td>
                                <td>تاريخ الميلاد</td>
                            </tr>
                            <tr>
                                <td>Nationality</td>
                                <td>{digitalCardData.nationality}</td>
                                <td>الجنسية</td>
                            </tr>
                            <tr>
                                <td>Expiry Date</td>
                                <td> {digitalCardData.expiryDate ? digitalCardData.expiryDate : '\u00A0'}</td>
                                <td>تاريخ الانتهاء</td>
                            </tr>
                        </table>
                    </div>
                </div>
                        </div>
                        <div className="digital_btn_box">
                            <button onClick={() => handleDownloadHealthCard()}
            className="blue_btn_link">
                                {translationMap?.download}
                            </button>
                        </div>
                    </div>
        }
            </section>


        </div>
    </>;
}

export default DigitalHealthCard;